import { Flex } from '@chakra-ui/react'
import BaseLayout from 'src/layouts/BaseLayout'
import AdminListCell from 'src/components/AdminListCell'

const AdminPage = () => {
  return (
    <BaseLayout>
      <Flex justifyContent="center" m={5}>
        <AdminListCell />
      </Flex>
    </BaseLayout>
  )
}

export default AdminPage
